import React from 'react';
import PropTypes from 'prop-types';
import { Switch, Route, Redirect, withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { routes } from '../constants';
import { changeNavigation } from '../redux/head/headActions';

import {
	AsbestPage,
	IndustrialPage,
	ContactIndustrialPage,
	PartnersPage,
	ReferencePage,
	CustomizationPage,
	ProductComparePage,
	ProjectOverviewPage,
	ProjectDetailPage,
	RentDetailPage,
	ProductDetailPage,
	ProductListPage,
	ProductCategoryPage,
	RentListPage,
	AboutUsPage,
	DocumentsPage,
	AtexPage,
} from '../pages';
/**
 * this is the router setup.
 */
class IndustrialRouting extends React.Component {
	componentDidMount() {
		this.props.changeNavigation('industrial');
	}

	render() {
		const index = routes.INDUSTRIAL.HOME;

		return (
			<Switch>
				<Route path={`${index}${routes.PRODUCT_DETAIL}${routes.COMPARE}`} component={ProductComparePage} />
				<Route path={`${index}${routes.RENT_DETAIL}${routes.COMPARE}`} component={ProductComparePage} />
				<Route path={`${index}${routes.PRODUCT_DETAIL}`} component={ProductDetailPage} />
				<Route path={`${index}${routes.PRODUCT_LIST}`} component={ProductListPage} />
				<Route path={`${index}${routes.PRODUCTS}`} component={ProductCategoryPage} />
				<Route path={`${index}${routes.RENT_DETAIL}`} component={RentDetailPage} />
				<Route path={`${index}${routes.RENT}`} component={RentListPage} />
				<Route path={`${index}${routes.PARTNERS}`} component={PartnersPage} />
				<Route path={`${index}${routes.ATEX}`} component={AtexPage} />
				<Route path={`${index}${routes.CUSTOMIZATION}`} component={CustomizationPage} />
				<Route path={`${index}${routes.ASBEST}`} component={AsbestPage} />
				<Route path={`${index}${routes.ABOUT_US}`} component={AboutUsPage} />
				<Route path={`${index}${routes.PROJECT}`} component={ProjectDetailPage} />
				<Route path={`${index}${routes.PROJECTS}`} component={ProjectOverviewPage} />
				<Route path={`${index}${routes.REFERENCE}`} component={ReferencePage} />
				<Route path={routes.INDUSTRIAL.DOCUMENTS} component={DocumentsPage} />
				<Route path={routes.INDUSTRIAL.CONTACT} component={ContactIndustrialPage} />
				<Route IndexLink path="" component={IndustrialPage} />
				<Route render={() => <Redirect to="" />} />
			</Switch>
		);
	}
}

IndustrialRouting.propTypes = {
	changeNavigation: PropTypes.func.isRequired,
};

export default withRouter(connect(null, {
	changeNavigation,
})(IndustrialRouting));



// WEBPACK FOOTER //
// ./src/router/industrial.routing.js